import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDeliveryNote } from "../../redux/features/CheckoutAddress";
import { useTranslation } from "react-i18next";
const AddNote = () => {
  const dispatch = useDispatch();
  const {t} = useTranslation();
  const { deliveryNotes } = useSelector((state: any) => state.checkoutAddress)
  return (
    <div className="md:p-5 p-4 bg-white md:rounded-[10px] md:mb-5 md:border-none border-t-2 border-b-2 border-[#E2E2E2]">
      <div className="flex justify-between  mb-4">
        <p className="text-xl font-splekta font-normal">{t("Checkout.addANote")}</p>
        <img src="/images/notes-icon.svg" />
      </div>
      <input
        className="ios-input w-full border-2 border-[#E7E7E7] bg-white rounded-lg py-3 px-3 textMd input-box-zoom"
        type="text"
        value={deliveryNotes}
        placeholder={t("MyAddress.writeTextHere")}
        onChange={(e:any)=>dispatch(setDeliveryNote(e.target.value))}
      />
    </div>
  );
};

export default AddNote;
